// =============================================================================
// Fermat.ts Index
// (c) Mathigon
// =============================================================================


export * from './arithmetic';
export * from './combinatorics';
export * from './complex';
export * from './xnumber';
export * as Matrix from './matrix';
export * from './number-theory';
export * as Random from './random';
export * as Regression from './regression';
export * from './statistics';
export * from './vector';
